var _circle, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBroadcastMicrophoneMute(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17291_93)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -20,
    y: -20,
    width: 120,
    height: 120
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_1_17291_93_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 20,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#6C757E",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4877 39.0208C51.4877 38.3817 50.9417 37.8652 50.2661 37.8652C49.5905 37.8652 49.0445 38.3817 49.0445 39.0208C49.0445 43.8795 44.8801 47.819 39.7439 47.819C34.6077 47.819 30.4432 43.8795 30.4432 39.0208C30.4432 38.3817 29.8972 37.8652 29.2216 37.8652C28.546 37.8652 28 38.3817 28 39.0208C28.0093 44.7024 32.5439 49.4648 38.513 50.0513V52.8527H33.6359C32.9604 52.8527 32.4144 53.3692 32.4144 54.0083C32.4144 54.6474 32.9974 55.1551 33.673 55.1551H45.8518C46.5273 55.1551 47.0733 54.6386 47.0733 53.9996C47.0733 53.3605 46.5273 52.844 45.8518 52.844H40.9839V50.0426C46.953 49.456 51.4877 44.7024 51.4877 39.0208Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7645 45.8075C43.7161 45.7987 46.9274 42.7697 46.9274 39.0316V30.8375C46.9644 27.0906 43.7902 24.0353 39.8293 24.0003C35.8684 23.9653 32.6386 26.968 32.6016 30.7149C32.6016 30.7587 32.6016 30.8025 32.6016 30.8462V39.0228C32.5923 42.7609 35.7944 45.8075 39.7645 45.8075C39.7552 45.8075 39.7552 45.8075 39.7645 45.8075ZM35.0355 30.8637C35.0633 28.395 37.2103 26.4078 39.82 26.4428C42.3928 26.469 44.4657 28.4388 44.4935 30.8637V39.0403C44.4657 41.5091 42.3187 43.4963 39.709 43.4613C37.1362 43.435 35.0633 41.4653 35.0355 39.0403V30.8637Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25L53 51",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_17291_93_clip_path",
    transform: "translate(20 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17291_93"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastMicrophoneMute);
export default __webpack_public_path__ + "static/media/broadcast-microphone-mute.88754ac383c970c446261308782ed2d7.svg";
export { ForwardRef as ReactComponent };